// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-row[data-v-0391ad7e]{margin:24px 0}.text-row[data-v-0391ad7e]  p{margin:24px 0;color:#2d3748;font-family:Roboto;font-size:16px;font-weight:400;line-height:24px;text-align:left}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
